import { createFeature, createReducer, on } from '@ngrx/store';
import { MaintenanceActions } from '@features/maintenance/store/maintenance.actions';
import { Maintenance } from '@features/maintenance/maintenance';

export interface MaintenanceState {
  isLoading: boolean;
  maintenance: Maintenance | null;
  error: string | null;
}

export const initialState: MaintenanceState = {
  isLoading: false,
  maintenance: null,
  error: null,
};

const maintenanceReducers = createReducer(
  initialState,

  on(MaintenanceActions.loadMaintenance, (state) => ({
    ...state,
    isLoading: true,
  })),

  on(
    MaintenanceActions.loadMaintenanceSuccess,
    (state, { maintenance }): MaintenanceState => ({
      ...state,
      isLoading: false,
      maintenance,
    })
  ),
  on(
    MaintenanceActions.loadMaintenanceFailure,
    (state, { error }): MaintenanceState => ({
      ...state,
      isLoading: false,
      error,
    })
  ),
);

export const maintenanceFeature = createFeature({
  name: 'maintenance',
  reducer: maintenanceReducers,
});
